import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	width: 100%;
	z-index: 2000;
`;

export const ContainerSelect = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 12px;
`;

export const ContainerButton = styled.div`
	button {
		height: 45px;
	}
`;
